import React from 'react';

const ConditionsGenerales = () => {
  return (
    <div className="page-container">
      <div className="page-content">
        <h1 className="page-title">Conditions Générales</h1>
        <div className="page-text">
          <p>Contenu à venir...</p>
        </div>
      </div>
    </div>
  );
};

export default ConditionsGenerales;
